import { defaultApiState } from "@/store/general.types";
import { ExcludedReasonState } from "./excluded-reason.types";

export const excludedReasonState: ExcludedReasonState = {
    getExcludedReasons: defaultApiState,
}


